import { Tabs } from 'components/FbUI/Tabs'
import React from 'react'

interface OpportunitiesTabsProps {
  noKnownRecords: boolean
  unmatched: boolean
  setUnmatched: (value: boolean) => void
}

const OpportunitiesTabs: React.FC<OpportunitiesTabsProps> = ({
  noKnownRecords,
  unmatched,
  setUnmatched,
}) => {
  const tabs = noKnownRecords
    ? [{ key: 'unmatched', title: 'Unmatched' }]
    : [
        { key: 'firstbite', title: 'First Bite' },
        { key: 'unmatched', title: 'Unmatched' },
      ]

  return (
    <>
      <Tabs
        tabs={tabs}
        selectedTab={unmatched ? 'unmatched' : 'firstbite'}
        setSelectedTab={(t) => setUnmatched(t === 'unmatched')}
        style={{
          borderBottom: 'none',
        }}
        tabStyle={{ width: '140px' }}
      />
    </>
  )
}

export default OpportunitiesTabs
